const BASE_URL = 'https://employee.prrepxpathshala.live';
const DEFAULT_IMAGE = `${BASE_URL}/PrepXPathshala_logo2.jpg`;
const SITE_NAME = 'Employee Portal - PrrepX Pathshala';

const pageMeta = {
  '/': {
    title: 'Employee Portal — PrrepX Pathshala',
    description: 'Internal employee management portal for PrrepX Pathshala. Manage attendance, tasks, salary, performance and more.',
  },
  '/login': {
    title: 'Login — Employee Portal | PrrepX Pathshala',
    description: 'Log in to the PrrepX Pathshala Employee Portal to access your dashboard, tasks, attendance and more.',
  },
  '/dashboard': {
    title: 'Dashboard — Employee Portal | PrrepX Pathshala',
    description: 'Your PrrepX Pathshala employee dashboard. View tasks, attendance, announcements and team updates.',
  },
  '/dashboard/my-portal': {
    title: 'My Portal — Employee Dashboard | PrrepX Pathshala',
    description: 'Your personal dashboard at PrrepX Pathshala. View your tasks, attendance summary, salary slips and performance.',
  },
  '/dashboard/manage': {
    title: 'Admin Panel — Employee Portal | PrrepX Pathshala',
    description: 'Admin management panel for PrrepX Pathshala. Manage employees, tasks, attendance and organizational settings.',
  },
  '/dashboard/experience-records': {
    title: 'Experience Records — Employee Portal | PrrepX Pathshala',
    description: 'View and manage employee experience records, work history and project contributions at PrrepX Pathshala.',
  },
  '/dashboard/employee-manual': {
    title: 'Employee Manual — PrrepX Pathshala',
    description: 'The official PrrepX Pathshala employee handbook. Policies, guidelines, and everything you need to know as a team member.',
  },
  '/dashboard/about': {
    title: 'About PrrepX Pathshala — Employee Portal',
    description: 'Learn about PrrepX Pathshala, our mission, values, and the team building India\'s most accessible learning platform.',
  },
  '/dashboard/email-portal': {
    title: 'Email Marketing Portal — PrrepX Pathshala Admin',
    description: 'Manage email marketing campaigns for PrrepX Pathshala. Create, schedule and track email communications.',
  },
  '/dashboard/whatsapp-portal': {
    title: 'WhatsApp Marketing Portal — PrrepX Pathshala Admin',
    description: 'Manage WhatsApp marketing campaigns for PrrepX Pathshala. Send updates and engage with students.',
  },
  '/dashboard/employee-list': {
    title: 'Employee Directory — PrrepX Pathshala',
    description: 'Browse the PrrepX Pathshala employee directory. Find team members, their roles and contact information.',
  },
  '/dashboard/manage-access': {
    title: 'Manage Access — Employee Portal | PrrepX Pathshala',
    description: 'Manage user access, permissions and roles for the PrrepX Pathshala Employee Portal.',
  },
  '/dashboard/offer-letter': {
    title: 'Offer Letter Generator — PrrepX Pathshala',
    description: 'Generate and manage official offer letters for new PrrepX Pathshala employees.',
  },
  '/dashboard/id-card': {
    title: 'ID Card Generator — PrrepX Pathshala',
    description: 'Generate official employee ID cards for PrrepX Pathshala team members.',
  },
  '/dashboard/prrepx-standard': {
    title: 'PrrepX Standard — Employee Portal | PrrepX Pathshala',
    description: 'Standardized HR resources for PrrepX Pathshala including important links, reusable email templates, and subscription tracking.',
  },
  '/dashboard/checklist-manager': {
    title: 'Checklist Manager — PrrepX Pathshala',
    description: 'Create and manage onboarding checklists and task templates for PrrepX Pathshala employees.',
  },
  '/dashboard/calendar': {
    title: 'Team Calendar — PrrepX Pathshala',
    description: 'View the PrrepX Pathshala team calendar. Track meetings, holidays, events and deadlines.',
  },
  '/dashboard/meet': {
    title: 'PrrepX Meet — Video Meetings | PrrepX Pathshala',
    description: 'Join or start video meetings with your PrrepX Pathshala team. Built-in meeting room for collaboration.',
  },
  '/dashboard/weekly-progress': {
    title: 'Weekly Performance — Employee Portal | PrrepX Pathshala',
    description: 'Track weekly performance and progress reports for PrrepX Pathshala employees.',
  },
};

const defaultMeta = {
  title: 'Employee Portal — PrrepX Pathshala',
  description: 'Internal employee management portal for PrrepX Pathshala. Manage attendance, tasks, salary, performance and more.',
};

export function getPageMeta(pathname) {
  const meta = pageMeta[pathname] || defaultMeta;
  return {
    title: meta.title,
    description: meta.description,
    image: meta.image || DEFAULT_IMAGE,
    url: `${BASE_URL}${pathname}`,
    siteName: SITE_NAME,
  };
}

export { pageMeta, defaultMeta, BASE_URL, DEFAULT_IMAGE, SITE_NAME };
